import React, {ChangeEvent, Fragment} from "react";
import {useDispatch} from "react-redux";
import {useAppSelector} from "../../../app/hooks";
import {User} from "../../../services/UsersService";
import {ZendeskUserField} from "../../../services/ZendeskService";
import {SliceStatus} from "../../BaseState";
import {updateZendeskUser, zendeskState} from "../ZendeskSlice";

interface ZendeskUserAssociationProps {
  readonly user: User;
}

const ZendeskUserAssociation = (props: ZendeskUserAssociationProps) => {
  const {user} = props;
  const state = useAppSelector(zendeskState);
  const dispatch = useDispatch();

  const addPrerenderIdToZendeskUser = () => {
    if (!state.ticket || !user) return;

    dispatch(
      updateZendeskUser({
        zendeskUserId: state.ticket.requester.id,
        update: {
          customFields: {
            prerenderId: user.id
          }
        }
      })
    );
  };

  const onIntegrationTypeChanged = (event: ChangeEvent<HTMLSelectElement>) => {
    if (!state.ticket || !user) return;

    dispatch(
      updateZendeskUser({
        zendeskUserId: state.ticket.requester.id,
        update: {
          customFields: {
            integrationType: event.target.value
          }
        }
      })
    );
  };

  const integrationTypes: ZendeskUserField | undefined = state.userFields.find((userField) => userField.title === "Integration Type");

  if (!state.insideZendesk) return <Fragment></Fragment>;

  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-header-title">Zendesk Actions</h4>
      </div>
      <div className="card-body">
        <div className="row align-items-center">
          {state.insideZendesk && (
            <div className="col">
              <button
                className="btn btn-primary"
                onClick={addPrerenderIdToZendeskUser}
                disabled={state.status === SliceStatus.loading || state.ticket?.requester.prerenderId === user.id}
              >
                Set Prerender Id to Zendesk User
              </button>
            </div>
          )}
        </div>
        <div className="row align-items-center">
          {state.insideZendesk && integrationTypes && (
            <div className="col">
              <select
                className="form-select mb-3"
                data-choices
                defaultValue={state.ticket?.requester.integrationType || "-"}
                onChange={onIntegrationTypeChanged}
              >
                <option>-</option>
                {integrationTypes.options!.map((integrationType) => {
                  return <option key={integrationType.id}>{integrationType.value}</option>;
                })}
              </select>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ZendeskUserAssociation;
